// utils/apiBase.js
// 本番では VITE_API_BASE（例: https://api.otoeigo.com）を使用し、
// 開発（vite dev）では相対パスでViteプロキシに流す。

export function getApiBase() {
  // VITE_API_BASE が優先。従来ルーター等で使われていた VITE_API_BASE_URL も同義として読む。
  const raw = import.meta.env.VITE_API_BASE || import.meta.env.VITE_API_BASE_URL || ''
  // 空文字の場合は相対パスのまま（Vite プロキシの /api など開発想定）
  return String(raw).replace(/\/$/, '')
}


